import React, { memo, useMemo } from 'react';
import LocationMC from './LocationMC';

// Memoized text formatter for replied text messages
const RepliedLocationMessageMC = memo(({ message }) => {
  const locationURL = useMemo(() => message.locationURL, [message.locationURL]);
  return (<LocationMC locationURL={locationURL} />);
});

RepliedLocationMessageMC.displayName = 'RepliedLocationMessageMC';

export default RepliedLocationMessageMC;
